import type { CanonicalDocument } from './canonical-document.js';
import type { Layer } from './layers.js';

/**
 * SUSTITUCIÓN DE ROLES: el documento de UN miembro de la serie.
 *
 * Un club encarga dieciocho camisetas iguales salvo nombre y dorsal. El diseño
 * BASE marca capas con `rol: 'nombre' | 'dorsal'`; esto devuelve el documento
 * con esos textos sustituidos por los del miembro. Es PURO y vive en
 * design-core porque lo usan tres sitios que no pueden divergir: la
 * previsualización del editor, la validación por miembro y el compositor de
 * producción del worker.
 *
 * Solo cambia `text`. Ni el cuerpo, ni la caja, ni la posición: si el nombre
 * más largo no cabe, eso lo dice la VALIDACIÓN del miembro, no un reescalado
 * silencioso que produciría dieciocho prendas con dieciocho cuerpos de letra.
 */
export interface MiembroSerie {
  nombre: string;
  dorsal: string;
}

export function documentoDeMiembro(base: CanonicalDocument, miembro: MiembroSerie): CanonicalDocument {
  return {
    ...base,
    layers: base.layers.map((capa): Layer => {
      if (capa.kind !== 'text' || capa.rol === undefined) return capa;
      const texto = capa.rol === 'nombre' ? miembro.nombre : miembro.dorsal;
      // Un miembro sin dorsal (o sin nombre) deja el hueco VACÍO, no el texto
      // del ejemplo: imprimir «GARCIA» en la camiseta de quien no dio nombre
      // es peor que imprimirla sin nombre.
      return { ...capa, text: texto };
    }),
  };
}

/** Los roles que el documento base declara, para validar la lista contra ellos. */
export function rolesDelDocumento(base: CanonicalDocument): Array<'nombre' | 'dorsal'> {
  const roles = new Set<'nombre' | 'dorsal'>();
  for (const capa of base.layers) {
    if (capa.kind === 'text' && capa.rol !== undefined) roles.add(capa.rol);
  }
  return [...roles];
}
